import { render, staticRenderFns } from "./AuthorListPage.vue?vue&type=template&id=04f91636&scoped=true&"
import script from "./AuthorListPage.vue?vue&type=script&lang=js&"
export * from "./AuthorListPage.vue?vue&type=script&lang=js&"
import style0 from "./AuthorListPage.vue?vue&type=style&index=0&id=04f91636&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f91636",
  null
  
)

export default component.exports